import type {AudioPlayer} from '$lib/classes/manager/audio-player.svelte';
import {SentenceManager} from '$lib/classes/manager/sentence-manager';
import {getContext, setContext} from 'svelte';
import type {WordId} from '$lib/classes/data/_primitives';
import type {LoggedIn} from '$lib/classes/stores/logged-in.svelte';
import type {Device} from '$lib/classes/state/device.svelte';
import type {Status} from '$lib/classes/data/user-word';
import type {ToastManager} from '$lib/classes/stores/toast-manager.svelte';

export const keyIsNativePlatform = Symbol('is-native-platform')
export const keyPlatform = Symbol('platform')
export const keyLoggedIn = Symbol('logged-in')
export const keyDevice = Symbol('device');
export const keyFunctions = Symbol('functions')
export const keyAuth = Symbol('auth')
export const keyToastManager = Symbol('toast-manager')
export const keyUserActionProcessor = Symbol('user-action-processor')
export const keySentenceManager = Symbol('sentence-manager')
export const keyAudioPlayer = Symbol('audio-player')
export const keyVerbConjugations = Symbol('verb-conjugations')
export const keyUserWordManager = Symbol('user-word-manager')

export const keyOnOpenRoute = Symbol('on-open-route')
export const keyOnNavigateViaWordId = Symbol('on-navigate-via-word-id')
export const keyOnUserWordStatusChange = Symbol('on-user-word-status-change')

//NOTE Maps in component tests can be typed Map<symbol, ContextValue>

export type ContextValue =
    | AudioPlayer
    | Device
    | LoggedIn
    | OnNavigateViaWordId
    | OnUserWordStatusChange
    | SentenceManager


// LoggedIn

export function setLoggedInContext(loggedIn: LoggedIn) {
    setContext(keyLoggedIn, loggedIn);
}

export function getLoggedInContext() {
    return getContext(keyLoggedIn) as LoggedIn
}

// Device

export function setDeviceContext(device: Device) {
    setContext(keyDevice, device);
}

export function getDeviceContext() {
    return getContext(keyDevice) as Device
}

// ToastManager

export function setToastManagerContext(toastManager: ToastManager) {
    setContext(keyToastManager, toastManager);
}

export function getToastManagerContext(): ToastManager {
    return getContext(keyToastManager) as ToastManager;
}

// browseRouteChange

type OnBrowseRouteChangeCallback = (wordId: WordId | null) => void

export function setOnBrowseRouteChangeContext(callback: OnBrowseRouteChangeCallback) {
    setContext(keyOnOpenRoute, callback)
}

export function getOnBrowseRouteChangeContext() {
    return getContext(keyOnOpenRoute) as OnBrowseRouteChangeCallback
}

// navigateViaWordId

export type OnNavigateViaWordId = (wordId: WordId) => void

export function setOnNavigateViaWordIdContext(callback: OnNavigateViaWordId) {
    setContext(keyOnNavigateViaWordId, callback)
}

export function getOnNavigateViaWordIdContext(): OnNavigateViaWordId {
    return getContext(keyOnNavigateViaWordId)
}

// userWordStatusChange

export type OnUserWordStatusChange = (wordId: WordId, newStatus: Status | null) => void

export function setOnUserWordStatusChangeContext(callback: OnUserWordStatusChange) {
    setContext(keyOnUserWordStatusChange, callback)
}

export function getOnUserWordStatusChangeContext(): OnUserWordStatusChange {
    return getContext(keyOnUserWordStatusChange)
}
